import { history } from '../services/history.service';

export function useHistory() {
  return history;
}
